export const changeTheme = colors => ({
  type: 'CHANGE_THEME',
  colors,
});
